__webpack_require__.p = "/tabula-rasa/";